// 1. 导入路由所需方法
import { createRouter, createWebHistory } from 'vue-router'

import admin from './admin.js'
import platform from './platform.js'

// 3. 配置路由规则（导航地址 ↔ 页面）
const routes = [
	...admin,
	...platform
]

// 4. 创建路由实例
const router = createRouter({
	history: createWebHistory(), // 路由模式（推荐）
	// base: '/',
	routes // 挂载路由规则
})

// 登录相关页自己负责跳转；扫码考核、文档公开预览、NCT 资源预览由页面自己解析 token/票据
const PUBLIC_PATHS = ['/login', '/AppLogin', '/singleLogin', '/logout', '/logoutUser', '/Unauthorized', '/scan-exam', '/doc/preview', '/nct/viewResource']

// 未登录时先拦在路由层：如果直接进 /home 等页面，页面组件会先渲染再用空用户信息请求接口，
// 既会报错也会让拦截器在“加载失败 → 跳登录”之间来回打转
router.beforeEach((to) => {
	const isPublic = PUBLIC_PATHS.some(path => to.path === path || to.path.startsWith(path + '/'))
	if (isPublic) return true
	if (localStorage.getItem('yjwltoken')) return true
	return { path: '/login' }
})

// 5. 导出路由，供 main.js 引入
export default router